module.exports = __webpack_public_path__ + "img/parLogo.84cf7c4b.svg";